import VehicleDetailsCard from './VehicleDetailsCard';

export default VehicleDetailsCard;
